import axios from 'axios';

// export const LOADER = "LOADER";
// export const loader = (bool) => ({
//   type: 'LOADER',
//   payload: bool,
// });

// export const Action = () => {
//
//   return async (dispatch) => {

//     dispatch(loader(true))
//     dispatch(Data(process.env.REACT_BASE_URL))
//     dispatch(loader(false))

//   }
// };
// export const DATA = "DATA";
// export const Data = (payload) => ({
//   type: 'Data',
//   payload: payload,
// });

export const CREATE_CATEGORY_LOADER = 'CREATE_CATEGORY_LOADER';
export const createCategoryLoader = bool => ({
  type: 'CREATE_CATEGORY_LOADER',
  payload: bool,
});

export const CREATE_SUB_CATEGORY_LOADER = 'CREATE_SUB_CATEGORY_LOADER';
export const createSubCategoryLoader = bool => ({
  type: 'CREATE_SUB_CATEGORY_LOADER',
  payload: bool,
});

export const createCategoryAction = obj => {
  return async dispatch => {
    if (obj.typeCategory === 'Main') {
      dispatch(createCategoryLoader(true));
    } else {
      dispatch(createSubCategoryLoader(true));
    }

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/create`,
      headers: {
        'content-type': 'application/json',
      },
      data: obj,
    };

    axios
      .request(config)
      .then(response => {
        dispatch(getCategoryAction(obj.bookId, obj.typeCategory));
        if (obj.typeCategory === 'Main') {
          dispatch(createCategoryLoader(false));
        } else {
          dispatch(createSubCategoryLoader(false));
        }
      })
      .catch(error => {
        if (obj.typeCategory === 'Main') {
          dispatch(createCategoryLoader(false));
        } else {
          dispatch(createSubCategoryLoader(false));
        }
      });
  };
};

export const UPDATE_SUB_CATEGORY_LOADER = 'UPDATE_SUB_CATEGORY_LOADER';
export const updateSubCategoryLoader = bool => ({
  type: 'UPDATE_SUB_CATEGORY_LOADER',
  payload: bool,
});

export const updateSubCategoryAction = (obj, id, clearStates, status) => {
  return async dispatch => {
    dispatch(updateSubCategoryLoader(true));
    const data = { ...obj, status };

    if (!status) delete data.status;
    delete data._id;
    delete data.__v;
    delete data.updatedAt;
    delete data.createdAt;
    delete data.index;

    const url = status ? `/api/v1/admin/categories/${id}/status` : `/api/v1/admin/categories/update?id=${id}`;

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url,
      headers: {
        'content-type': 'application/json',
      },
      data,
    };

    axios
      .request(config)
      .then(response => {
        clearStates();

        dispatch(getCategoryAction(obj.bookId, obj.typeCategory));
        // dispatch(CategoryData(response.data.data))
        dispatch(updateSubCategoryLoader(false));
      })
      .catch(error => {
        dispatch(updateSubCategoryLoader(false));
      });
  };
};

export const UPDATE_BULK_CATEGORY_LOADER = 'UPDATE_BULK_CATEGORY_LOADER';
export const updateBulkCategoryLoader = bool => ({
  type: 'UPDATE_BULK_CATEGORY_LOADER',
  payload: bool,
});

export const updateBulkCategoryAction = (arr, setLoader) => {
  return async dispatch => {
    dispatch(updateBulkCategoryLoader(true));
    if (setLoader) {
      setLoader(true);
    }
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/bulkUpdate`,
      headers: {
        'content-type': 'application/json',
      },
      data: arr,
    };

    axios
      .request(config)
      .then(response => {
        dispatch(getCategoryAction(arr[0].bookId, arr[0].typeCategory));
        // dispatch(CategoryData(response.data.data))
        dispatch(updateBulkCategoryLoader(false));
        if (setLoader) {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        }
      })
      .catch(error => {
        dispatch(updateBulkCategoryLoader(false));
        if (setLoader) {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        }
      });
  };
};

export const GET_CATEGORY_LOADER = 'GET_CATEGORY_LOADER';
export const getCategoryLoader = bool => ({
  type: 'GET_CATEGORY_LOADER',
  payload: bool,
});

export const getCategoryAction = (bookId, type) => {
  return async dispatch => {
    dispatch(getCategoryLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/get?${bookId ? `bookId=${bookId}&` : ''}typeCategory=${type}`,
      headers: {
        'content-type': 'application/json',
      },
    };

    axios
      .request(config)
      .then(response => {
        //   clearStates()

        if (type === 'Main') {
          dispatch(CategoryData(response.data.data));
        } else if (type === 'Sub') {
          dispatch(subCategoryData(response.data.data));
        }
        dispatch(getCategoryLoader(false));
      })
      .catch(error => {
        dispatch(getCategoryLoader(false));
      });
  };
};

export const DELETE_CATEGORY_LOADER = 'DELETE_CATEGORY_LOADER';
export const deleteCategoryLoader = bool => ({
  type: 'DELETE_CATEGORY_LOADER',
  payload: bool,
});

export const deleteCategoryAction = (id, type, bookId, setDeleteLoader, functionCall) => {
  return async dispatch => {
    setDeleteLoader(true);
    // dispatch(deleteCategoryLoader(true))

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/delete?id=${id}`,
      headers: {
        'content-type': 'application/json',
      },
    };

    axios
      .request(config)
      .then(response => {
        //   clearStates()
        dispatch(getCategoryAction(bookId, type));
        // dispatch(CategoryData(response.data.data))
        // dispatch(deleteCategoryLoader(false))
        setDeleteLoader(false);
        functionCall();
      })
      .catch(error => {
        // dispatch(deleteCategoryLoader(false))
        setDeleteLoader(false);
      });
  };
};

export const UPDATE_CATEGORY_LOADER = 'UPDATE_CATEGORY_LOADER';
export const updateCategoryLoader = bool => ({
  type: 'UPDATE_CATEGORY_LOADER',
  payload: bool,
});

export const updateCategoryAction = (obj, id, type, bookId, setUpdateLoader) => {
  return async dispatch => {
    setUpdateLoader(true);
    dispatch(updateCategoryLoader(true));
    delete obj._id;
    delete obj.__v;
    delete obj.updatedAt;
    delete obj.createdAt;
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/update?id=${id}`,
      headers: {
        'content-type': 'application/json',
      },
      data: obj,
    };

    axios
      .request(config)
      .then(response => {
        //   clearStates()

        dispatch(getCategoryAction(bookId, type));
        // dispatch(CategoryData(response.data.data))
        setUpdateLoader(false);
        dispatch(updateCategoryLoader(false));
      })
      .catch(error => {
        setUpdateLoader(false);
        dispatch(updateCategoryLoader(false));
      });
  };
};

export const CATEGORY_DATA = 'CATEGORY_DATA';
export const CategoryData = payload => ({
  type: 'CATEGORY_DATA',
  payload: payload,
});

export const SUB_CATEGORY_DATA = 'SUB_CATEGORY_DATA';
export const subCategoryData = payload => ({
  type: 'SUB_CATEGORY_DATA',
  payload: payload,
});

export const GET_CATEGORIES_POST_LOADER = 'GET_CATEGORIES_POST_LOADER';
export const getCategoriesPostLoader = bool => ({
  type: 'GET_CATEGORIES_POST_LOADER',
  payload: bool,
});

export const getCategoriesPostAction = (bookId, refId) => {
  return async dispatch => {
    dispatch(getCategoriesPostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/getCategories?${refId ? `refId=${refId}&` : ''}${
        bookId ? `bookId=${bookId}` : ''
      }`,
      headers: {
        'content-type': 'application/json',
      },
    };

    axios
      .request(config)
      .then(response => {
        //   clearStates()

        dispatch(
          getCategoriesPostData({
            data: response.data.data ? response.data.data : [],
          })
        );
        // dispatch(CategoryData(response.data.data))

        dispatch(getCategoriesPostLoader(false));
      })
      .catch(error => {
        dispatch(getCategoriesPostLoader(false));
      });
  };
};

export const getAllCategoriesAction = (bookId, refIds) => {
  return async dispatch => {
    dispatch(getCategoriesPostLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/categories/getAllCategories?${refIds ? `refIds=${refIds.join(',')}&` : ''}${
        bookId ? `bookId=${bookId}` : ''
      }`,
      headers: {
        'content-type': 'application/json',
      },
    };

    axios
      .request(config)
      .then(response => {
        dispatch(
          getAllCategoriesData({
            data: response.data.data ? response.data.data : [],
          })
        );

        dispatch(getCategoriesPostLoader(false));
      })
      .catch(error => {
        dispatch(getCategoriesPostLoader(false));
      });
  };
};

export const GET_CATEGORIES_POST = 'GET_CATEGORIES_POST';
export const getCategoriesPostData = payload => ({
  type: 'GET_CATEGORIES_POST',
  payload: payload,
});

export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
export const getAllCategoriesData = payload => ({
  type: 'GET_ALL_CATEGORIES',
  payload: payload,
});
